// queries/getProfileBanner.ts

import datoCMSClient from './datoCMSClient';
import { ProfileBanner } from '../types';

const GET_PROFILE_BANNERS = `
  query {
    allProfileBanners {
      profileName: profilename
      backgroundImage {
        url
      }
      backgroundVideo: backgroundvideo {
        url
      }
      headline
      resumeLink {
        url
      }
      linkedinLink
      profileSummary
    }
  }
`;

export async function getProfileBanner(profileName: ProfileBanner['profileName']): Promise<ProfileBanner> {
  const data = await datoCMSClient.request<{
    allProfileBanners: ProfileBanner[];
  }>(GET_PROFILE_BANNERS);

  const matchedBanner = data.allProfileBanners.find((banner) => banner.profileName === profileName);

  if (!matchedBanner) {
    throw new Error(`No profile banner found for ${profileName}`);
  }

  return matchedBanner;
}
